import './AnimatedBrand.css';

import { Bot, Sparkles } from 'lucide-react';
import type { CSSProperties } from 'react';

import type { AnimatedBrandProps } from './AnimatedBrand.types';

// Brand lockup choreographed on a shared 4s loop that plays on hover: the bot
// icon wiggles and emits a ping ring, a sparkle twinkles by its corner, and a
// wave of light runs letter by letter through the wordmark. Animations live in
// AnimatedBrand.css; letters are aria-hidden with an sr-only full label.
export const AnimatedBrand = ({ label, className = '' }: AnimatedBrandProps) => (
	<span className={`animated-brand flex items-center gap-xs ${className}`}>
		<span className="relative inline-flex">
			<span className="animated-brand__ping absolute inset-0 rounded-md bg-purple-500" aria-hidden="true" />
			<span className="animated-brand__icon relative inline-flex h-xl w-xl items-center justify-center rounded-md bg-purple-500 text-white">
				<Bot className="h-[14px] w-[14px]" aria-hidden="true" />
			</span>
			<Sparkles
				className="animated-brand__sparkle absolute -right-3xs -top-3xs h-[10px] w-[10px] text-purple-400"
				aria-hidden="true"
			/>
		</span>
		<span className="text-[13px] font-semibold leading-none">
			<span className="sr-only">{label}</span>
			{label.split('').map((char, index) => (
				<span
					// eslint-disable-next-line react/no-array-index-key -- static label, order never changes
					key={`${char}-${index}`}
					aria-hidden="true"
					className="animated-brand__letter"
					style={{ '--i': index } as CSSProperties}
				>
					{char === ' ' ? '\u00A0' : char}
				</span>
			))}
		</span>
	</span>
);
